export function MiniBarTable({
  rows,
  max,
}: {
  rows: { key: string; count: number }[];
  max?: number;
}) {
  const mx = max ?? Math.max(1, ...rows.map((r) => r.count));
  if (!rows.length) return <p className="text-sm text-pp-quiet">Sin datos</p>;
  return (
    <ul className="space-y-1.5 text-sm">
      {rows.map((r) => (
        <li key={r.key} className="flex items-center gap-2">
          <span className="flex-1 min-w-0 truncate text-pp-main" title={r.key}>
            {r.key || "—"}
          </span>
          <span className="tabular-nums text-pp-muted w-8 text-right">{r.count}</span>
          <div className="w-24 h-2 bg-pp-soft rounded overflow-hidden shrink-0 ring-1 ring-pp-border/60">
            <div
              className="h-full rounded bg-pp-gradient"
              style={{ width: `${Math.round((r.count / mx) * 100)}%` }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}

export function KpiCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="pp-card-flat p-4 shadow-sm">
      <div className="text-xs uppercase tracking-wide text-pp-muted font-medium">{label}</div>
      <div className="text-lg font-semibold tabular-nums text-pp-main">{value}</div>
    </div>
  );
}

export function SemaphoreList({
  items,
}: {
  items: { level: "green" | "yellow" | "red"; text: string }[];
}) {
  const dot = {
    green: "bg-emerald-500",
    yellow: "bg-amber-400",
    red: "bg-red-500",
  };
  return (
    <ul className="space-y-2 text-sm">
      {items.map((x, i) => (
        <li key={i} className="flex gap-2 items-start">
          <span
            className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${dot[x.level]}`}
            aria-hidden
          />
          <span className="text-pp-main">{x.text}</span>
        </li>
      ))}
    </ul>
  );
}
